import { createAction } from 'typesafe-actions';

export const clearSubscription = createAction(
  'subscription/clearSubscription',
  (resolve) => (actionUid: string) => resolve({ actionUid })
);
